import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        footerClass: 'footer',
        isChatActivated: '',
        playerUrl: '',
        playerUrlEs: '',
        playerUrlCat: '',
        posterStartEn: '',
        posterEndEn: '',
        posterStartEs: '',
        posterEndEs: '',
        posterStartCat: '',
        posterEndCat: '',
        panicPoster: '',
        role: '',
        isLoading: false,
        navBarClass: '',
        showEventComponent: false
    },
    mutations: {
        updateFooterClass(state, value) {
            state.footerClass = value
        },
        updateIsLoading(state, value) {
          state.isLoading = value
        },
        updatePlayerUrl(state, value) {
            state.playerUrl = value;
        },
        updatePlayerUrlEs(state, value) {
            state.playerUrlEs = value
        },
        updatePlayerUrlCat(state, value) {
            state.playerUrlCat = value
        },
        updatePosterStartEn(state, value) {
            state.posterStartEn = value
        },
        updatePosterEndEn(state, value) {
            state.posterEndEn = value
        },
        updatePosterStartEs(state, value) {
            state.posterStartEs = value
        },
        updatePosterEndEs(state, value) {
            state.posterEndEs = value
        },
        updatePosterStartCat(state, value) {
            state.posterStartCat = value
        },
        updatePosterEndCat(state, value) {
            state.posterEndCat = value
        },
        updateRole(state, value) {
            state.role = value
        },
        updateNavBarClass(state, value) {
            state.navBarClass = value
        },
        updateIsChatActivated(state, value) {
            state.isChatActivated = value
        },
        updateShowEventComponent(state, value){
            state.showEventComponent = value
        },
        updatePanicPoster(state, value){
            state.panicPoster = value
        }
    },
    actions: {},
    modules: {}
})
